<div class="row">
    <div>
        <div *ngIf="productPriceList">
            <h6>Agregar Producto</h6>
        </div>
        <div class="row mb-4" *ngIf="productPriceList">
            <div class="col">
                <app-input-autocomplete
                    [allBorderRadius]="true"
                    [inputs]="inputs.product"
                    [placeholder]="'Ingresa un producto'"
                    [filterElements]="filterProducts"
                    [typeElements]="'product-order'"
                    (inputMethod)="writeProduct($event.event)"
                    (changeStatus)="checkProduct($event.filterElement)"
                    (getTitle)="
                        $event.filterElement.title =
                            $event.filterElement.code +
                            ' - ' +
                            $event.filterElement.name
                    "
                ></app-input-autocomplete>
            </div>
            <div class="input-group col" style="max-width: 10rem;">
                <input type="number" 
                    placeholder="Precio" 
                    class="form-control"
                    [(ngModel)]="price"
                    [disabled]="this.inputs.product.value == null"
                    >
                <button class="btn btn-success btn-sm" (click)="addPrice()" [disabled]="this.inputs.product.value == null"
                    >
                    <i class="fa fa-save" ></i>
                </button>
            </div>
        </div>
        <div>
            <div *ngIf="productPricesList.length === 0">
                <p class="muted">
                    <i class="fa fa-circle-info"></i> No se tiene detalles, debes agregar.
                </p>
            </div>
            <div class="row">
                <div>
                    <h5>Detalles</h5>
                </div>
                <div class="row" id="options-other-filters" *ngIf="productPriceList">
                    <div class="col-sm form-group">
                        <label for="filterVendors" class="form-label">Filtrar</label>
                        <div class="input-group input-group-sm">
                            <input
                                type="text"
                                id="filter"
                                [(ngModel)]="filterWord"
                                (input)="onInputChange($event)"
                                placeholder="Filtra pedidos por usuario o bodega"
                                name="filter"
                                class="form-control"
                            />
                            <button class="btn btn-primary" (click)="searching()">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="mb-4" *ngIf="productPricesList.length > 0">
                    <table class="table table-striped table-responsive">
                        <thead>
                            <tr class="tr-middle limit-td">
                                <th class="d-flex flex-row">
                                    <div class="d-flex flex-col items-start">
                                        Producto
                                        <span class="font-medium" style="font-size: 0.75em;">Código</span>
                                    </div>
                                </th>
                                <th class="text-left">Medida</th>
                                <th class="text-right">Precio</th>
                                <th class="text-center">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="!loadingProducts">
                                <ng-container *ngFor="let item of pagination.filter">
                                    <tr (click)="setPriceListSelected(item)" class="hover:bg-gray-100 px-2">
                                        <td class="limit-td">
                                            <div class="d-flex flex-col items-start">
                                                <span class="font-semibold">{{item.name}}</span>
                                                <span class="font-medium" style="font-size: 0.75em;">
                                                    {{item.code}}
                                                </span>
                                            </div>
                                        </td>
                                        <td class="text-left">
                                            {{item.measurementName}}
                                        </td>
                                        <td class="text-right">
                                            <div class="input-group-sm d-flex flex-row justify-end" style="max-width: 9rem;" *ngIf="editPrice[item.id]">
                                                <input type="number" 
                                                    placeholder="Costo" 
                                                    class="form-control"
                                                    [(ngModel)]="item.price"
                                                    >
                                                <button class="btn btn-success" (click)="updatePrice(item)"
                                                    >
                                                    <i class="fa fa-save" ></i>
                                                </button>
                                            </div>
                                            <div *ngIf="!editPrice[item.id]">
                                               Q {{item.price}}
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <div class="d-flex flex-wrap items-center justify-center gap-1">
                                                <span class="a-hover" (click)="editingPrice(item)">
                                                    <i class="fa fa-edit text-primary"></i>
                                                </span>
                                                <ng-container *ngIf="loadingSave">
                                                    <span  class="a-hover">
                                                        <i class="fa fa-floppy-disk"></i>
                                                    </span>
                                                </ng-container>
                                                <ng-container *ngIf="!loadingSave">
                                                    <span  class="a-hover" (click)="deletePrice(item)">
                                                        <i class="fa fa-trash text-danger"></i>
                                                    </span>
                                                </ng-container>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                            <tr class="tr-middle" *ngIf="loadingProducts">
								<td colspan="4">
									<app-loading-animation [height]="'5rem'"></app-loading-animation>
									<p class="display-6">Cargando</p>
								</td>
							</tr>
                        </tbody>
                    </table>
                    <app-pagination-custom [elements]="pagination"></app-pagination-custom>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row"></div>